import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  preferences: {
    vehicleType: null,
    salesChannel: 1,
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setVehicleType: (state, action) => {
      state.preferences.vehicleType = action.payload;
    },
    setSalesChannel: (state, action) => {
      state.preferences.salesChannel = action.payload;
    },
    updatePreferences: (state, action) => {
      state.preferences = { ...state.preferences, ...action.payload };
    },
  },
});

export const { setVehicleType, setSalesChannel, updatePreferences } = userSlice.actions;

export const selectPreferences = (state) => state.user.preferences;

export default userSlice.reducer;
